
import React, { FunctionComponent, useEffect, useState } from 'react';
import TopBar from '../../Components/TopBar/TopBar';
import commonStyle from '../common.module.css';

import CustomTable from '../../Components/CustomTable/CustomTable';
import { getDataFromRoute } from '../../Services/contacts';
import { connect, useDispatch } from 'react-redux';
import {
  setClearFilter,
  showSnackbarAction,
  setFilterObject,
  setRefreshContacts,
  // setContactDrillDownClearFilter
} from '../../Redux/actions';
import axios from 'axios';
import Cookies from 'universal-cookie';
import moment from 'moment';

import { contactFilterValues, localstorageKey, url } from '../../Values/constants';
import {
  CONTACT_COLUMNS,
  datesField,
  booleanObject,
  CONTACT_DRILLDOWN_COLUMNS,
  CONTACT_DRILLDOWN_COLUMNS_REAL,
} from '../../Values/tables';
import Firebase from 'firebase/app';
import ApiTopBar from '../../Components/TopBar/ApiTopBar';
import ApiCustomTable from '../../Components/CustomTable/ApiCustomTable';
import Loading from '../../Components/Loading/Loading';
import { fetchOrganizationsUsers, fetchOrganizationsUsersFromMongo, googleAnalytics } from "../../Services/users";
import { themeColors } from "../../Components/theme";
import { getDateString } from '../../Values/utils';
import PopUpBox from "../AuditLogs/PopUpBox";
import axiosHandler from '../../Services/axiosHandler';

type props = {
  history: any;
  user: any;
  searchString: string;
  filterSort: any;
  filterObject: any;
  role: string;
  organizationUsers: any[];
  refreshContacts: any;
  organizationId: string;
  theme: any;
  authToken:any;
  organizationData:any;
};
let usersList: any[] = [];
let isFinished = false;
const ApiDrilldownPanel: FunctionComponent<props> = ({
  history,
  user,
  searchString,
  filterSort,
  filterObject,
  role,
  organizationUsers,
  refreshContacts,
  organizationId,
  theme,
  authToken,
  organizationData
}) => {
  const [searchedItem, setsearchedItem] = useState('');
  const [columnModal, setColumnModal] = useState(false);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);

  const [lastPage, setLastPage] = useState(-1);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allLeads, setAllLeads] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>(undefined);
  const [drillDownCount, SetDrillDownCount] = useState<any>({});
  const [localStorageData, setLocalStorageData] = useState<any>({});
  const [uid, setuid] = useState<any>({});
  const [filterApiCount, SetFilterApiCount] = useState<any>({});
  const [drillRole, setDrillRole] = useState<any>({});
  const [associate, setassociate] = useState<any>({});
  const [userBranchMap, setBranchMap] = useState<any>(undefined);
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [userTeamMap, setTeamMap] = useState<any>(undefined);
  const dispatcher = useDispatch();
  const cookies = new Cookies();

  let userId = user.uid;
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [userEmail, setUserEmail] = useState<any>(undefined);   
  const [showColumns, setShowColumns] = useState<any>(null);
  const createUsersList = (email: string, users: any[], uid: boolean) => {
    users.map((item: any) => {
      if (usersList.includes(item)) {
        return;
      } else {
        if (item.reporting_to === email && item.status === 'ACTIVE') {
          if (!usersList.includes(item)) {
            usersList.push(item);
          }

          createUsersList(item.user_email, users, uid);
        }
      }
    });
  };

  useEffect(() => {
    if (localStorageData.organizationid) {
      // const unSub = fetchOrganizationsUsers(
      //   dispatcher,
      //   localStorageData.organizationid
      // );
      // return () => {
      //   unSub();
      // };
      fetchOrganizationsUsersFromMongo(dispatcher,localStorageData.organizationid);
    }
  }, [localStorageData, dispatcher,user]);

  useEffect(() => {
    // console.log("CSASADC",organizationUsers)
    if (organizationUsers) {
      let uids: { [key: string]: string } = {};
      let uidsBranch: { [key: string]: string } = {};
      let uidsTeam: { [key: string]: string } = {};
      // To store info of user
      let emailInfo: { [key: string]: string } = {};
      organizationUsers.forEach((user: any) => {
        uids[user.user_email] = user.reporting_to;
        uidsBranch[user.user_email] = user.branch;
        uidsTeam[user.user_email] = user.team;
        emailInfo[user.user_email]=user;
      });
      setBranchMap(uidsBranch)
      setUserMap(uids);
      setTeamMap(uidsTeam)
      setUserEmail(emailInfo)
    }
  }, [organizationUsers,user]);
  useEffect(() => {
    var key: any;
    const preserveLocalStorageFields = localstorageKey;
    for (var i = 0; i < localStorage.length; i++) {
      key = localStorage.key(i);

      if (!preserveLocalStorageFields.includes(key) && key !== 'columns' && key !== 'drilldownData'  && key !== 'isLightMode' && key !== 'totalMonths' && key !== 'lastAlertTime') {
        localStorage.removeItem(key);
      }
    }
    dispatcher(setClearFilter(true));
    // dispatcher(setContactDrillDownClearFilter(true));
    const savedData = localStorage.getItem('drilldownData');
    if (savedData) {
      setLocalStorageData(JSON.parse(savedData));
    }
  }, [searchString]);
  // console.log("searchStringsearchStringsearchString",searchString)

  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    }
    else {
      setLoad(true);
      const filters: { [key: string]: any[] } = { ...localStorageData.leadFilter };

      if (localStorageData.source === true) {
        filters['source_status'] = ['True'];
      }
      else {
        filters['associate_status'] = ['True'];
      }
      setDrillRole(localStorageData.role);
      let feild;

      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          filters[item] = filterObject[item];
        }
      });
      if (searchString === '') {
        feild = 'contact_no';
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = 'contact_no';
        } else {
          feild = 'customer_name';
        }
      }
      // console.log("filterssssssssssssssssssssssssssssssss",localStorageData)
      const { reporting_to, team, branch, ...objLeadUserFilterValues } = filters;
      let records = localPageSize ? localPageSize : pageSize;
      // console.log("teammmmmmmmmmmmmmmmmmm",team,localStorageData.uid)
      const apiData = {
        uid: localStorageData.source === true && localStorageData.role === false ? user.uid : localStorageData.uid,
        organizationid: localStorageData.organizationid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: '-1' }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        taskFilter: localStorageData.taskFilter,
        leadUserFilter: {
          reporting_to,
          team:localStorageData.team,
          branch
        },
        leadFilter: localStorageData.source === true && localStorageData.role === false ? { ...objLeadUserFilterValues, "lead_source": [localStorageData.uid] } : objLeadUserFilterValues,
        role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
        teamUids: localStorageData.teamUids ? localStorageData.teamUids : []

      };
      SetDrillDownCount(filters);
      SetFilterApiCount(apiData)
      try {
        // axios.defaults.headers.common['x-access-token'] =
        //   authToken
        const res = await axiosHandler.post(url + '/leads/drillDownSearch', apiData);
        let data: any[] = res.data;
        if (data.length < records) {
          isFinished = true;
          setLastPage(page);
        }
        data.forEach((lead) => {
          lead.contactId = lead.Id;
          lead["reporting_to"] = userMap[lead.contact_owner_email];
          lead["branch"] = userBranchMap[lead.contact_owner_email];
          lead["team"] = userTeamMap[lead.contact_owner_email];
          if (userEmail && userEmail[lead.contact_owner_email]) {
          let info=userEmail[lead.contact_owner_email];
          if(info){
            lead.employee_id=info.employee_id?info.employee_id:"";
              if(info.user_first_name || info.user_last_name){
                lead.employee_name=info.user_first_name+" "+info.user_last_name;
              }
          }
        }
          delete lead['Id'];
          Object.keys(lead).forEach((key) => {
            if (datesField.includes(key) && lead[key] !== '') {
              if (lead[key] !== null) {
                lead[key] = Firebase.firestore.Timestamp.fromDate(
                  moment(lead[key]).toDate()
                );
              } else {
                lead[key] = '';
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          // console.log("newDataaaaaaaaaaaaaaaaaaaaaa",newData)
          setFilterData(newData);
        } else {
          
          setFilterData(data);
        }
        // console.log("dataaaaaaaaaaaaaaaaaaaaahhdshdshd",data)
        setLoad(false);
      } catch (error) {
        setFilterData([]);
        setLoad(false);
        // dispatcher(showSnackbarAction('Please Try Again!!', 'error'));
      }
    }
  };
  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [allLeads, filterObject, userMap, localStorageData,authToken,user]);

  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken,user]);
  useEffect(() => {
    if (localStorageData.uid === undefined) {
      setFilterData([]);
      return;
    }
    if(authToken){
      callCountApi();
    }
  }, [refreshContacts, localStorageData.uid, drillDownCount, filterApiCount,authToken,user]);

  const callCountApi = async () => {
    const filterValues: { [key: string]: any[] } = {};
    Object.keys(drillDownCount).forEach((item) => {
      if (drillDownCount && drillDownCount[item].length > 0) {
        if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status") {
          if (drillDownCount[item].length === 2) {
            filterValues[item] = [true, false];
          } else {
            if(item === "transfer_status"){
              filterValues[item] = drillDownCount[item];
            }else{
              filterValues[item] =
              drillDownCount[item][0] === "True" ? [true] : [false];
            }
          }
        }
        else filterValues[item] = drillDownCount[item];
      }
    });
    const { reporting_to, team, branch, ...objLeadFilterDrillDownCount } = filterValues;
    if (drillRole === true) {
      // axios.defaults.headers.common['x-access-token'] =
      // authToken
      const res = await axiosHandler.post(url + '/leads/contacttotalcount', {
        uid: localStorageData.uid,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        leadFilter: objLeadFilterDrillDownCount,
        taskFilter: localStorageData.taskFilter,
        teamUids: localStorageData.teamUids ? localStorageData.teamUids : [],
        role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
        panel:"drilldown"
      });
      setTotalCounts(res.data.total);
    }
    else {
      const uId = localStorageData.uid
      // axios.defaults.headers.common['x-access-token'] =
      // authToken
      const res = await axiosHandler.post(url + '/leads/contacttotalcount', {
        uid: localStorageData.source === true && localStorageData.role === false ? user.uid : uId,
        leadUserFilter: {
          reporting_to,
          team,
          branch
        },
        leadFilter: localStorageData.source === true && localStorageData.role === false ? { ...objLeadFilterDrillDownCount, "lead_source": [uId] } : { ...objLeadFilterDrillDownCount, "uid": [uId] },
        taskFilter: localStorageData.taskFilter,
        teamUids: localStorageData.teamUids ? localStorageData.teamUids : [],
        role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
        panel:"drilldown"
      });
      setTotalCounts(res.data.total);
    }
  };

  useEffect(() => {
    if (refreshContacts === true) {
      if(authToken){
        callApi();
      getContactsFilter();
      dispatcher(setRefreshContacts(false));
      }
    }
  }, [refreshContacts,authToken,user]);

  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('contactShowFilterValues');
  //   setShowColumns(storedValue);
  //   getContactsFilter();
  // },[localStorage.getItem('contactShowFilterValues'),showColumns])

  const getContactsFilter = async () => {
    const uId = localStorageData.uid
    // axios.defaults.headers.common['x-access-token'] =
    //   authToken
    const res = await axiosHandler.post(url + '/leads/filterValues', {
      uid: localStorageData.source === true && localStorageData.role === false ? user.uid : uId,
      teamUids: localStorageData.teamUids ? localStorageData.teamUids : [],
      role: localStorageData.source === true && localStorageData.role === false ? true : localStorageData.role,
      showColumns:showColumns === null?contactFilterValues:JSON.parse(showColumns)
    });
    const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
      organization_id: user.organization_id,
      uid: user.uid,
      });
    if (res.data[0]) {
      // console.log("GRESfverv",userdetail.data.data)
      // console.log("GRESfverv",user)
      dispatcher(setFilterObject({ ...res.data[0], ...booleanObject ,'employee_name':userdetail.data.data.Employee_Name,'employee_id':userdetail.data.data.Employee_id,'lead_type':['Data','Leads']}));
    } else {
      dispatcher(setFilterObject({}));
    }
  };

  useEffect(() => {
    const storedValue = localStorage.getItem('contactShowFilterValues');
    setShowColumns(storedValue);
    if (localStorageData.uid === undefined) {
      return;
    }
    if(user && authToken){
      getContactsFilter();
    }
  }, [localStorageData.uid,authToken,user,localStorage.getItem('contactShowFilterValues'),showColumns]);

  const setUsersList = () => {
    if (role === 'Lead Manager') {
      organizationUsers.map((item: any) => {
        if (usersList.includes(item)) {
          return;
        } else {
          if (item.status === 'ACTIVE') {
            usersList.push(item);
          }
        }
      });
    } else {
      createUsersList(user.user_email, organizationUsers, false);
    }
  };

  const exportFile = () => {
    let data: any[] = [];
    if (selectedRowsData.length !== 0) {
      selectedRowsData.forEach((item,index) => {
        data.push({
          "S.NO":index+1,
          "Customer Name": item?.customer_name,
          "Country Code": item?.country_code,
          "Contact Number": item?.contact_no,
          "Alternate Number": item?.alternate_no,
          "Lead Source": item?.lead_source,
          // "Created At": item?.created_at?.toDate(),
          "Created On": getDateString(item?.created_at),
          "Previous Lead Assignee Email 1": item?.previous_owner_1,
          "Lead Assignee Email": item?.contact_owner_email,
          "Customer Email": item?.email,
          "Previous Lead Assignee Email 2": item?.previous_owner_2,
          "Lead Stage": item?.stage,
          "Reporting To": item?.reporting_to,
          // "Transfer By 1": item?.transfer_by_1,
          "Call Back Reason": item?.call_back_reason,
          "Property Stage": item?.property_stage,
          "Property Type": item?.property_type,
          "Property Sub Type": item?.property_sub_type,
          "Location": item?.location,
          "Project": item?.project,
          "Budget": item?.budget,
          "Inventory Type": item?.inventory_type,
          "Campaign": item?.campaign,
          "Addset": item?.addset,
          "Not Interested Reason": item?.not_int_reason,
          "Lost Reason": item?.lost_reason,
          "Other Not Interested Reason": item?.other_not_int_reason,
          "Other Lost Leason": item?.other_lost_reason,
          // "Previous Lead Assignee Email": item?.previous_owner,
          "Transfer Status": item?.transfer_status,
          "Associate Status": item?.associate_status,
          "Source Status": item?.source_status,
          "Transfer By": item?.transfer_by_2,
          "Next Follow Up On": getDateString(item?.next_follow_up_date_time),
          "Next Follow Up Type": item?.next_follow_up_type,
          "Created By": item?.created_by,
          // "Previous Lead Stage 1": item?.previous_stage_1,
          "Previous Lead Stage": item?.previous_stage_2,
          "Transfer Reason": item?.transfer_reason,
          // "ModifiedAt": item?.modified_at?.toDate(),
          // "StageChange At": item?.stage_change_at?.toDate(),
          // "LeadAssignTime": item?.lead_assign_time?.toDate(),
          "Modified On": getDateString(item?.modified_at),
          "Lead Stage Changed On": getDateString(item?.stage_change_at),
          "Lead Assigned On": getDateString(item?.lead_assign_time),
          // "IsButtonCalled": item?.is_button_called,
          // "FeedbackTime": item?.feedback_time?.toDate(),
          "Feedback Time": getDateString(item?.feedback_time),
          "Branch": item?.branch,
          "Team": item?.team,
          "Lead Type": item?.lead_type,
          // "Id": item._id,
          // "Customer Image":item?.customer_image,
          // "Organization Id":item?.organization_id,
          // "Uid":item?.uid,
          // "V":item?.__v,
          // "ContactId":item?.contactId,
          "Employee ID":item.employee_id,
          "Lead Assignee": item.employee_name,
          "Lead State": item.state,
        });
      });
    }
    return data;
  };
  // console.log("filterDataaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa6575675678567",filterData)
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Contact_DrillDown_Screen',user)
      }
    }
  },[user])
  return (
    <div style={{ height: "100vh", ...containerStyles }}>
      <div className={commonStyle.topBar} style={containerStyles}>
        <ApiTopBar
          history={history}
          title={'Add Contacts'}
          path={'/addContacts'}
          changeOwner={() => {
            setUsersList();
          }}
          onChange={(val) => setsearchedItem(val)}
          filterText={'Status'}
          setColumnModal={(data) => setColumnModal(data)}
          show={true}
          showStatusBox={true}
          searchedString={searchString}
          setAllLeads={(data) => setAllLeads(data)}
          onExport={exportFile}
          titleDrillDown={'Drill Down'}
          selectedRows={selectedRows}
          setAuditLog={setAuditLog}
          isOtpVerified={isOtpVerified}
          panel = "contacts drilldown"
        />
      </div>

      <div className={commonStyle.parent} style={{ height: "81%", ...containerStyles }}>
        {load === true && <Loading />}
        {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
        <ApiCustomTable
          tableColumns={CONTACT_DRILLDOWN_COLUMNS_REAL}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="User"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setPage={(val) => setPage(val)}
          setPageSize={(val) => setPageSize(val)}
          callApi={callApi}
          pageSize={pageSize}
          page={page}
          isFinished={isFinished}
          totalCount={totalCounts}
          lastPage={lastPage}
          DrillDownpanel = "contacts drilldown"
          panel="Contacts Drilldown"
        />:
        <ApiCustomTable
          tableColumns={CONTACT_DRILLDOWN_COLUMNS}
          tableRows={filterData}
          selectedRows={selectedRows}
          setSelectedRows={(data) => setSelectedRows(data)}
          tableType="User"
          showColumnModal={columnModal}
          hideColumnModal={() => setColumnModal(false)}
          selectedRowsData={selectedRowsData}
          setSelectedRowsData={(data) => setSelectedRowsData(data)}
          setPage={(val) => setPage(val)}
          setPageSize={(val) => setPageSize(val)}
          callApi={callApi}
          pageSize={pageSize}
          page={page}
          isFinished={isFinished}
          totalCount={totalCounts}
          lastPage={lastPage}
          DrillDownpanel = "contacts drilldown"
        />
        }
        {auditLog && (
              <PopUpBox
                open={auditLog}
                close={() => setAuditLog(false)}
                setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
                onExport={exportFile}
                selectedRows={selectedRows}
              panel = "contacts drilldown"
              />)}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    // filterSort: state.filterSort,
    filterSort: state.contactDrillDownfilterSort,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    // filterObject: state.filter,
    filterObject: state.contactDrillDownFilter,
    organizationUsers: state.organizationUsers.data,
    organizationId: state.organization.id,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
  };
};
export default connect(mapStateToProps)(ApiDrilldownPanel);
